import { createProviderToken } from '@core/common-legacy';
import { HttpApi } from '@core/http-types';

// Api service used by all core reports data features
export const { inject: injectReportsHttpApiService, provide: provideReportsHttpApiService } =
  createProviderToken<HttpApi>('ReportsApiService')();
